/**
 * Created by Timur on 27.08.2026
 */

const Merge2MissionBubblesStack = function (saved) {
    cleverapps.EventEmitter.call(this);

    this.stack = saved ? Merge2MissionBubblesStack.parseSaved(saved) : [];
};

Merge2MissionBubblesStack.prototype = Object.create(cleverapps.EventEmitter.prototype);
Merge2MissionBubblesStack.prototype.constructor = Merge2MissionBubblesStack;

Merge2MissionBubblesStack.prototype.top = function () {
    return this.stack[this.stack.length - 1];
};

Merge2MissionBubblesStack.prototype.size = function () {
    return this.stack.length;
};

Merge2MissionBubblesStack.prototype.isEmpty = function () {
    return this.stack.length === 0;
};

Merge2MissionBubblesStack.prototype.push = function (code, stage, data) {
    this.stack.push({ code, stage, data });

    this.trigger("changed");
};

Merge2MissionBubblesStack.prototype.fill = function () {
    const config = bundles.merge2mission_config.jsons.merge2mission_bubblesstack_json.getJson();

    (config.initialStack || []).forEach((item) => this.push(item.code, item.stage));
};

Merge2MissionBubblesStack.prototype.pop = function () {
    const item = this.stack.pop();

    this.trigger("changed");

    return item;
};

Merge2MissionBubblesStack.parseSaved = function (saved) {
    const data = saved.data || {};
    const stack = [];

    for (let index = 0; index * 2 < saved.cells.length; index++) {
        const unit = Merge2MissionFamilies.decodeUnit(saved.cells.substr(index * 2, 2));
        stack.push({ code: unit.code, stage: unit.stage, data: data[index] });
    }

    return stack;
};

Merge2MissionBubblesStack.prototype.getInfo = function () {
    const data = {};

    this.stack.forEach((item, index) => {
        if (item.data) {
            data[index] = item.data;
        }
    });

    return {
        cells: this.stack.map((item) => Merge2MissionFamilies.encodeUnit(item.code, item.stage)).join(""),
        data: Object.keys(data).length ? data : undefined
    };
};
